import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from 'react'; //jelly

import { Content } from '@jelly/components';
import * as Components from './Components'; // Styled Components via Emotion

var ContentWrapper = _styled("div", {
  target: "est1exz0",
  label: "ContentWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "j9ad5u",
  styles: "height:auto;width:100%;"
} : {
  name: "j9ad5u",
  styles: "height:auto;width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
}); //The node can be just a string (text nodes)


var createChildren = function createChildren(children, data, styles) {
  return children.map(function (node) {
    if (typeof node === 'string') {
      return node;
    } else {
      var _node$props = node.props,
          props = _node$props === void 0 ? null : _node$props,
          component = node.component;

      var _children = node.children && createChildren(node.children, data, styles);

      if (Components[component]) {
        if (data[component]) {
          props = _objectSpread(_objectSpread({}, props || {}), data[component]);
        }

        component = Components[component];
      }

      if (_children !== undefined) {
        return /*#__PURE__*/React.createElement.apply(React, [component, props].concat(_toConsumableArray(_children)));
      } else {
        return /*#__PURE__*/React.createElement(component, props);
      }
    }
  });
};
/**
 * This is the Content Body component
 * Most likely used in the "middle" part of an article template
 *
 * Splits out the html,
 * Inputs resource download button before and after content if it exists
 * Finds and places all the areas where RFQ is referenced
 */


export var ContentBody = function ContentBody(_ref) {
  var bestPicks = _ref.bestPicks,
      resource = _ref.resource,
      json = _ref.json,
      subtitle = _ref.subtitle,
      template = _ref.template,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'article' : _ref$type; //Array to add inline styles serialized

  var styles = []; //Inital children call

  var children = createChildren(json, //data to be injected on widgets by component
  {
    ContentResource: {
      resource: resource,
      type: type
    },
    BestPicks: {
      bestPicks: bestPicks,
      template: template
    }
  }, styles);
  return /*#__PURE__*/React.createElement(ContentWrapper, null, subtitle && /*#__PURE__*/React.createElement("h2", null, subtitle), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement.apply(React, ['main', null].concat(_toConsumableArray(children)))));
};